<template>
    <b-container fluid>
        <b-row>
            <b-col lg="6" class="my-1">    
            <b-form-group
                  label="Filtrar"
                  label-cols-sm="3"
                  label-align-sm="right"
                  label-size="sm"
                  label-for="filterInput"
                  class="mb-0"
            >
                <b-input-group size="sm">
                    <b-form-input
                      v-model="filter"
                      type="search"
                      id="filterInput"
                      placeholder="Escriba para filtrar"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
            </b-col>

            <b-col sm="5" md="6" class="my-1">
                <b-form-group
                  label="Por página"
                  label-cols-sm="6"
                  label-cols-md="6"
                  label-cols-lg="3"
                  label-align-sm="right"
                  label-size="sm"
                  label-for="perPageSelect"
                  class="mb-0"
                >
                  <b-form-select
                    v-model="perPage"
                    id="perPageSelect"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
            </b-form-group>
            </b-col>
        </b-row>
        <b-table 
            striped hover 
            responsive
            small
            :sticky-header="maxWidth(windowWidth)"

            :items="items" 
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"

            :filter="filter"
            :filterIncludedFields="filterOn"
            @filtered="onFiltered"

            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"

            >
            <template v-slot:cell(acciones)="row">
                <b-button :disabled="isDisabled(row.item)" size="sm" class="mb-1" @click="cerrar(row.item, row.index, $event.target)"
                data-toggle="tooltip" data-placement="top" title="Cambia el estado de la orden a cerrada"
                >
                    Cerrar
                </b-button>
                <b-button size="sm" class="mb-1" @click="observacion(row.item, row.index, $event.target)"
                    data-toggle="toottip" data-placement="top" title="Agrega una observacion para preprensa"
                >
                    Observación
                </b-button>
                

            </template>
            <!--
            <template v-for="field in fields"
                :slot="field.key" slot-scope="data">
                <b-form-input class="border-0 no-shadow p-1" type="number" v-model="items.item[field.key]"></b-form-input>
            </template>
            -->
            <template v-slot:cell(orden)="row" >
                <b-form-input
                type="text"
                v-model="row.item.orden"
                size="sm"
                @change="orden(row.item)"
                />
            </template>

            <template v-slot:cell(url)="row">
                <b-form-checkbox v-model="row.detailsShowing" @change="row.toggleDetails">
                    ver detalles
                </b-form-checkbox>
            </template>
            <template v-slot:cell(comentario_ingenieria)="row">
                 <ul v-for="(comentario, key) in comentarios" :key="key"><!--row.item -->
                        <li v-if=" comentario.salesid == row.item.id" >
                   
                            {{comentario.comentario}}
                        </li>
                    </ul>
            </template>

            <template v-slot:row-details="row">
                <b-card>
                    <ul v-for="(url, key) in urls" :key="key"><!--row.item -->
                        <li v-if=" url.idsolicitud == row.item.id" >
                   
                            <b-link :href="url.link" target="_blank">{{url.link}}</b-link>
                        </li>
                    </ul>
                </b-card>
            </template>
           


        </b-table>
        <!-- Info modal -->
        <b-modal :id="infoModal.id"  :title="infoModal.title" @show="resetModal" @hidden="resetModal" @ok="handleOk" :ok-disabled="!wait">
            <form ref="form" @submit.stop.prevent="handleSubmit">  
                <b-form-group
                    :state="commentState"
                    label="Comentario"
                    label-for="name-input"
                    invalid-feedback="El comentario es obligatorio para cerrar la orden."
                  >
                    <b-form-input
                      id="name-input"
                      v-model="infoModal.comentario"
                      :state="commentState"
                      required
                    ></b-form-input>

                  </b-form-group>
            </form>  
        </b-modal>
        <!-- modal observacion -->
        <b-modal :id="observacionModal.id" :title="observacionModal.title" @show="resetModal" @hidden="resetModal" @ok="handleOOK">
            <form ref="form" @submit.stop.prevent="observacionSubmit">
               <b-form-group
                    :state="commentState"
                    label = "Observación"
                    invalid-feedback="Introduzca alguna observación"
                >
                <b-form-input
                    id="observacion-input"
                    v-model="observacionModal.observacion"
                    :state="commentState"
                    required
                >

                </b-form-input>
                </b-form-group>
                
            </form>
        </b-modal>
        <!-- Paginacion -->
        <b-pagination
                  v-model="currentPage"
                  :total-rows="items.length"
                  :per-page="perPage"
                  align="center" 
                  
                  class="my-0"
                >
        </b-pagination>
  
    </b-container>
</template>

<script>
    import {mapActions,mapMutations,mapState} from 'vuex'
    //import userForm from '@/components/admin/userForm'
    import validateMixin from '@/mixins/validation' //para usar el mixin de vee-validate
    import customMixin from '@/mixins/customMixin'

    export default {
        components:{
            //userForm
        },  
        mixins : [validateMixin,customMixin],
        props:{
            items:{
                type: Array,
                required: true
            },
            fields:{
                type: Array,
                required:true
            },
            urls:{
                type: Array,
                required: true
            },
            comentarios:{
                type: Array,
                required: true    
            }
        },
        data:function(){
            return{
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 50, 100],
                sortBy: '',
                sortDesc: false,
                sortDirection: 'asc',

                infoModal: {
                    id: 'info-modal',
                    title: '',
                    comentario: ''
                },
                observacionModal:{
                    id: 'observacion',
                    title: '',
                    observacion: ''
                },
                id:'',
                commentState: null,
                filter:'',
                filterOn: [],
                totalRows: 1,
                item:[],
                wait:true,
                
               
            }
               
        },
        computed:{
            ...mapState(['windowWidth']),//llamamos al estado.
        },
        mounted(){
            //
        },
        methods:{
            ...mapActions({
                _cerrar: 'ingenieria/cerrarOrden',
                _ordenar: 'ingenieria/guardarOrdenar',
                
            }),
            
            /**
             * Metodo que verifica si una orden esta cerrada y deshabilita el boton.
             */
            isDisabled(newVal){
                    if (newVal.status === "Cerrada"){
                        return this.disable = true
                    }
                
            },
            /**
             * metodo que le da orden 
             */
            orden(item){
                let payload
                payload = {
                    'id': item.id,
                    'orden': item.orden
                }
                this._ordenar(payload).then(() => {
                    console.log('actualizado')
                })
            },
            /**
             * metodo que activa el modal de observacion
             */
                
            observacion(item, index, button){
                this.observacionModal.title = `Orden #: ${item.id}`
                this.item = item
                this.$root.$emit('bv::show::modal', this.observacionModal.id, button)
            },
            cerrar(item, index, button){
                this.infoModal.title = `Orden #: ${item.id}`
                this.item = item
                this.$root.$emit('bv::show::modal', this.infoModal.id, button)
            },
            async observacionSubmit(){
                let payload
                let url = 'api/ingenieriaobservacion'
                let values = new FormData()
                if (!this.checkFormValidity()) {
                    return
                }
                payload = {
                    'id': this.item.id,
                    'observacion': this.observacionModal.observacion
                }
                values.append('id',payload.id)
                values.append('observacion', payload.observacion)
                values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')
                try{
                    await this.axios({
                        method:'POST',
                        url: url,
                        data: values
                    })
                    this.clearErrors()   
                    this.$router.go(0) 
                } 
                catch(error){
                    this.$toasted.show(error, {
	 					duration : 3000
						})
                }
            },            
            async handleSubmit() {
                let payload
                let url = "api/ingenieriacerrar"//direccion de la api
                let values = new FormData()
                // si no es valido sale de la funcion
                if (!this.checkFormValidity()) {
                    return
                }
                this.wait  = false
                payload =
                    {'id':  this.item.id, 
                    'comentario' : this.infoModal.comentario
                    }
                values.append('id',payload.id)
                values.append('comentario',payload.comentario)    
                try{
                    await this.axios({
                        method:'POST',
                        url: url,
                        data: values
                    })
                    this.wait = true
                    this.clearErrors()   
                    this.$router.go(0) 
                }  catch(error){
                    this.$toasted.show(error, {
	 					duration : 3000
						})   
                }
            },
            resetModal() {
               this.infoModal.comentario = ''
               this.observacionModal.observacion = ''
               
            },
            handleOOK(bvModalEvt){
                bvModalEvt.preventDefault()
                this.observacionSubmit()
            },
            handleOk(bvModalEvt) {
                bvModalEvt.preventDefault()
                this.handleSubmit()
            },
            checkFormValidity() {
                const valid = this.$refs.form.checkValidity()
                this.commentState = valid
                return valid
            },
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
            },
            clearErrors(){
                this.reset = true
                this.errors.clear();
                this.$validator.reset()
        }
        }//methods
        
    }//export
</script>

<style lang="scss" scoped>

</style>